import axios from "axios";

export const state = {
    // patient_saving: false,
    pendingsamples: [],
    testsamples: [],
    pendingtests: [],
    testresults: [],
    resultoptions: [],
    pendingreview: [],
    testdetail: {},
    organisms:[],
    microbioresults:[],
    antibiotics: [],
    datetime: "",
    lab_antibiotics: [],
    lab_organisms: [],
    lab_samples: [],
    picking_status:false,
    adding_result_status:false,
    result_review_status:false,
    suggestions:[],
    microbiologyReview:{},
    lab_items: [],
};
export const getters = {
    all_pending_sample: state => state.pendingsamples.data,
    get_test_sample: state => state.testsamples,
    pending_test: state => state.pendingtests.data,
    test_results: state => state.testresults.data,
    test_options: state => state.resultoptions.data,
    pending_review: state => state.pendingreview.data,
    test_detail: state => state.testdetail,
    test_to_review: state => state.microbiologyReview,
    organisms: state => state.organisms.data,
    microbio_results: state => state.microbioresults,
    antibiotics: state => state.antibiotics.data,
    date_time: state => state.datetime,
    labantibiotics: state => state.lab_antibiotics.data,
    laborganisms: state => state.lab_organisms.data,
    labsamples: state => state.lab_samples.data,
    PickingStatus:state=>state.picking_status,
    AddingResultStatus:state=>state.adding_result_status,
    ResultReviewStatus:state=>state.result_review_status,
    ResultSuggestions:state=>state.suggestions,
    LabItems: state => state.lab_items.data,
};

export const mutations = {
    SET_PENDING_SAMPLE(state, newValue) {
        state.pendingsamples = newValue
    },
    SET_TEST_SAMPLES(state, newValue) {
        state.testsamples = newValue
    },
    SET_TEST_OPTIONS(state, newValue) {
        state.resultoptions = newValue
    },
    PICKING_STATUS(state, newValue) {
        state.picking_status = newValue
    },
    SET_PENDING_TESTS(state, newValue) {
        state.pendingtests = newValue
    },
    SET_TEST_RESULTS(state, newValue) {
        state.testresults = newValue
    },
    SET_PENDING_REVIEW(state, newValue) {
        state.pendingreview = newValue
    },
    SET_MICRO_TEST_DETAIL(state, newValue) {
        state.testdetail = newValue
    },
    SET_MICRO_TEST_REVIEW(state, newValue) {
        state.microbiologyReview = newValue
    },
    SET_ORGANISMS(state, newValue) {
        state.organisms = newValue
    },
    SET_MICRO_TEST_RESULTS(state, newValue) {
        state.microbioresults = newValue
    },
    SET_ANTIBIOTICS(state, newValue) {
        state.antibiotics = newValue
    },
    RESET_TEST_SAMPLE(state) {
        state.testsamples = []
    },
    SET_DATE_TIME(state, timedata) {
        state.datetime = timedata
    },
    SET_LAB_ANTIBIOTICS(state, newValue) {
        state.lab_antibiotics = newValue
    },
    SET_LAB_ORGANISMS(state, newValue) {
        state.lab_organisms=newValue
    },
    SET_LAB_SAMPLES(state, newValue) {
        state.lab_samples=newValue
    },
    ADDING_RESULT_STATUS(state, newValue) {
        state.adding_result_status=newValue
    },
    RESULT_REVIEW_STATUS(state, newValue) {
        state.result_review_status=newValue
    },
    SET_RESULT_SUGGESTIONS(state, newValue) {
        state.suggestions=newValue
    },
    SET_LAB_ITEMS(state, newValue) {
        state.all_lab_items = newValue;
    },

};
export const actions = {
    fetchPendingSample({ commit }) {
        axios.get('pending_sample').then(samp => {
            commit('SET_PENDING_SAMPLE', samp.data)
        })
    },
    fetchTestSample({ commit, dispatch }, test_id) {
        commit('PICKING_STATUS', true)
        axios.get(`get_samples/${test_id}`).then(sample => {
            commit('SET_TEST_SAMPLES', sample.data)
            commit('PICKING_STATUS', false)
            if (sample.data.length < 1){
                let message = { 'msg': 'Sorry! No sample matching test found' }
                dispatch('notification/error', message, { root: true })
            }
        })
    },
    getDefinedOptions({ commit }, test) {
        axios.get(`pendingtests/${test}`).then(option => {
            commit('SET_TEST_OPTIONS', option.data)
        })
    },
    fetchPendingResult({ commit }) {
        axios.get('pendingtests').then(pending => {
            commit('SET_PENDING_TESTS', pending.data)
        })
    },
    fetchResultReports({ commit }) {
        axios.get('testsreport').then(result => {
            commit('SET_TEST_RESULTS', result.data)
        })
    },

    addSample({ dispatch, commit }, sampleData) {
        commit('PICKING_STATUS', true)
        axios.post('testsample', sampleData).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchPendingSample')
            let message = { 'msg': 'Success! Sample recorded successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! Sample taking failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    addOrganisms({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.post('organisms', payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabOrganisms')
            let message = { 'msg': `Success! Organism ${payload.name} recorded successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! Recording new organism failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    editOrganism({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.put(`organisms/${payload.id}`, payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabOrganisms')
            let message = { 'msg': 'Success! Organism updated successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! updating organism failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteOrganism({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.delete(`organisms/${payload.id}`).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabOrganisms')
            let message = { 'msg': `Success! Organism ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! deleting organism failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addLabSubstance({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.post('labsubstances', payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabAntibiotics')
            let message = { 'msg': `Success! Organism ${payload.name} recorded successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! Recording new organism failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    editLabSubstance({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.put(`labsubstances/${payload.id}`, payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabAntibiotics')
            let message = { 'msg': `Success! Antibiotic ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! updating Antibiotic failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteLabSubstance({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.delete(`labsubstances/${payload.id}`).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabAntibiotics')
            let message = { 'msg': `Success! Antibiotic ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! deleting Antibiotic failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addLabSample({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.post('samples', payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabSamples')
            let message = { 'msg': `Success! Sample Type ${payload.name} recorded successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! Recording new Sample type failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    editLabSample({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.put(`samples/${payload.id}`, payload).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabSamples')
            let message = { 'msg': `Success! Sample type ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! updating Sample type failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteLabSample({ dispatch, commit }, payload) {
        commit('PICKING_STATUS', true)
        axios.delete(`samples/${payload.id}`).then(() => {
            commit('PICKING_STATUS', false)
            dispatch('fetchLabSamples')
            let message = { 'msg': `Success! Sample type ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('PICKING_STATUS', false)
            let message = { 'msg': 'Error! deleting Sample type failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addDefinedResults({ dispatch, commit }, definedData) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('add_result_defined', definedData).then(response => {
            commit('ADDING_RESULT_STATUS', false)
            dispatch('fetchPendingResult')
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else {
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Results adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addUndefinedResults({ dispatch, commit }, undefinedData) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('add_result_undefined', undefinedData).then(() => {
            commit('ADDING_RESULT_STATUS', false)
            dispatch('fetchPendingResult')
            let message = { 'msg': 'Success! Result added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Results adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addMachineResults({ dispatch, commit }, undefinedData) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('add_machine_result', undefinedData).then(() => {
            commit('ADDING_RESULT_STATUS', false)
            dispatch('fetchPendingResult')
            let message = { 'msg': 'Success! Result added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Results adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addParameterResults({ dispatch, commit }, parameterData) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('parametertests', parameterData).then(() => {
            commit('ADDING_RESULT_STATUS', false)
            dispatch('fetchPendingResult')
            dispatch('fetchSuggestions')
            let message = { 'msg': 'Success! Result added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Results adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchPendingReview({ commit }) {
        axios.get('pending_review').then(review => {
            commit('SET_PENDING_REVIEW', review.data)
        })
    },

    fetchTestDetail({ commit }, order) {
        axios.get(`test_detail/${order.orderId}`).then(detail => {
            commit('SET_MICRO_TEST_DETAIL', detail.data)
        })
    },

    fetchTestToReview({ commit }, order) {
        axios.get(`test_to_review/${order.orderId}`).then(detail => {
            commit('SET_MICRO_TEST_REVIEW', detail.data)
        })
    },

    fetchOrganisms({ commit }) {
        axios.get("organisms").then(organ => {
            commit('SET_ORGANISMS', organ.data)
        })
    },

    fetchTestResults({ commit }, order) {
        axios.get(`microbio_results/${order.serviceId}/${order.visitId}`).then(micro => {
            commit('SET_MICRO_TEST_RESULTS', micro.data)
        })
    },

    fetchAntibiotics({ commit }) {
        axios.get("labsubstances").then(antibio => {
            commit('SET_ANTIBIOTICS', antibio.data)
        })
    },

    addTestOrganism({ dispatch, commit }, data) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('add_organism', data).then(() => {
            dispatch('fetchTestResults', data)
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Success! Organism added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Organism adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteTestOrganism({ dispatch, commit }, data) {
        commit('ADDING_RESULT_STATUS', true)
        axios.delete(`delete_organism/${data.id}`).then(() => {
            dispatch('fetchTestResults', data)
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Success! Organism removed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Organism removing failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteTestDrug({ dispatch, commit }, data) {
        commit('ADDING_RESULT_STATUS', true)
        axios.delete(`delete_result/${data.id}`).then(() => {
            dispatch('fetchTestResults', data)
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Success! Susceptibility result removed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Susceptibility result removing failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },
    editTestDrug({ dispatch, commit }, data) {
        commit('ADDING_RESULT_STATUS', true)
        axios.put(`edit_antibio_result/${data.id}`, data).then(() => {
            dispatch('fetchTestResults', data)
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Success! Susceptibility result updated successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Susceptibility result updating failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    addMicrobioResult({ dispatch, commit }, data) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('add_susceptibility', data).then(() => {
            dispatch('fetchTestResults', data)
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Success! Organism added successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Organism adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

    resetSample({ commit }) {
        commit('RESET_TEST_SAMPLE')
    },

    fetchDateTime({ commit }) {
        axios.get("get_datetime").then(time => {
            commit('SET_DATE_TIME', time.data)
        })
    },

    definedResultReview({dispatch, commit},definedResult) {
        commit('RESULT_REVIEW_STATUS', true)
        axios.post('review_result', definedResult).then(() => {
            commit('RESULT_REVIEW_STATUS', false)
            dispatch('fetchPendingReview')
            let message = { 'msg': 'Success! Result reviewed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('RESULT_REVIEW_STATUS', false)
            let message = { 'msg': 'Ops! Result reviewing failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    undefinedResultReview({dispatch, commit},undefinedResult) {
        commit('RESULT_REVIEW_STATUS', true)
        axios.post('review_undefined_result', undefinedResult).then(() => {
            commit('RESULT_REVIEW_STATUS', false)
            dispatch('fetchPendingReview')
            let message = { 'msg': 'Success! Result reviewed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('RESULT_REVIEW_STATUS', false)
            let message = { 'msg': 'Ops! Result reviewing failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    paraResultReview({dispatch, commit},parameterResult) {
        commit('RESULT_REVIEW_STATUS', true)
        axios.post('review_parameter', parameterResult).then(() => {
            commit('RESULT_REVIEW_STATUS', false)
            dispatch('fetchPendingReview')
            let message = { 'msg': 'Success! Result reviewed successfully' }
            dispatch('notification/success', message, { root: true })
        }).catch(()=>{
            commit('RESULT_REVIEW_STATUS', false)
            let message = { 'msg': 'Ops! Result reviewing failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchLabAntibiotics({ commit }) {
        axios.get("labsubstances").then(labsub => {
            commit('SET_LAB_ANTIBIOTICS', labsub.data)
        })
    },

    fetchLabOrganisms({ commit }) {
        axios.get("organisms").then(organ => {
            commit('SET_LAB_ORGANISMS', organ.data)
        })
    },

    fetchLabSamples({ commit }) {
        axios.get("samples").then(sample => {
            commit('SET_LAB_SAMPLES', sample.data)
        })
    },

    fetchSuggestions({ commit }) {
        axios.get("general_result").then(gen => {
            commit('SET_RESULT_SUGGESTIONS', gen.data)
        })
    },

    fetchLabItems({ commit }) {
        axios.get('labconsumables').then(ec_res => {
            commit('SET_LAB_ITEMS', ec_res.data)
        })
    },

    addConsumed({ dispatch, commit }, usedData) {
        commit('ADDING_RESULT_STATUS', true)
        axios.post('save_consumed', usedData).then(res => {
            commit('ADDING_RESULT_STATUS', false)
            if (res.status==200){
                let message = { 'msg': res.data.msg }
                dispatch('notification/success', message, { root: true })
            }else if (res.status==202){
                let message = { 'msg': res.data.msg }
                dispatch('notification/error', message, { root: true })
            }

        }).catch(()=>{
            commit('ADDING_RESULT_STATUS', false)
            let message = { 'msg': 'Error! Consumable adding failed. Try again' }
            dispatch('notification/error', message, { root: true })
        })
    },


};